export default {
    appVersion: process.env.VUE_APP_VERSION.split('-')[0],
    env: process.env.VUE_APP_mode || 'dev',
    httpHost: window.location.host,
    httpProtocol: window.location.protocol,
    api: process.env.VUE_APP_api || 'dev-api.nuwarobotics.com',
    account: process.env.VUE_APP_account || 'dev-account.nuwarobotics.com',
    webSocketProtocol: window.location.protocol === 'https' ? 'wss://' : 'wss://',
    userCenterUrl: process.env.VUE_APP_userCenterUrl || 'dev-account.nuwarobotics.com',
    rmsConnectionWebsocketUrl: process.env.VUE_APP_rmsConnectionWebsocketUrl || 'dev-rms-connection.nuwarobotics.com',
    quickConnectionWebsocketUrl: process.env.VUE_APP_quickConnectionWebsocketUrl || 'dev-mibo-connection.nuwarobotics.com',
    toolConnectionWebsocketUrl: process.env.VUE_APP_toolConnectionWebsocketUrl || 'dev-developtool-connection.nuwarobotics.com',
    iotUrl: process.env.VUE_APP_iot_url || 'wss://dev-codelab-mqtt.nuwarobotics.com/mqtt',
    nuwaWebsiteUrl: [
        {langCode: 'zh-CN', url: 'https://www.nuwarobotics.com/zh-hans/product/'},
        {langCode: 'zh-TW', url: 'https://www.nuwarobotics.com/zh-hant/product/'},
        {langCode: 'en-US', url: 'https://www.nuwarobotics.com/en/product/'},
        {langCode: 'ja-JP', url: 'https://www.nuwarobotics.com/ja/product/'},
        {langCode: 'ko-KR', url: 'https://www.nuwarobotics.com/en/product/'}
    ]
}
